<template>
<div class="col-sm-12">
<div class="card mt-20">
  <div class="card-body min-550  bg-secondary" v-if="userAcess">
    <h5><i class="fa fa-lock"></i> Accesos y Permisos para {{ user.name }}</h5>
    <p class="small text-danger">Precaución</p>
    <p class="small text-muted">A continuación se mostrarán los Departamentos disponibles donde se podrá dar acceso y permisos de lectura, escritura, modificación y eliminación de registros.</p>
    <div v-for="(dep, index) in userAcess.departments" :key="index">
      <div class="card-title" 
          data-toggle="collapse"
          :data-target="'#collapseDep'+index">
        <label class="btn-action" :class="{'active': dep.active}" data-toggle="tooltip" data-placement="top" title="Acceso al departamento" >
          <input class="d-none" type="checkbox" :checked="dep.active" v-model="dep.active">  
          <i class="fa fa-uncheck" :class="{'fa-check': dep.active}"></i>                                       
        </label>
        <button
          class="btn btn-link btn-dpto"
          type="button"
        >{{ dep.caption }}</button>
      </div>
      <div class="mt-2 collapse" :class="{'show': dep.active}" :id="'collapseDep'+index" v-if="dep.active">
        <div class="card card-body showAll">
          <!-- Menu Iteration -->
          <div v-for="(menu, indexMenu) in dep.menu" :key="indexMenu">
            <div class="card-title" data-toggle="collapse"
                :data-target="'#collapseMenu_'+ dep.id+ '_' + indexMenu"
                aria-expanded="false">
              <button
                class="btn btn-link btn-menu"
                type="button"
                data-toggle="collapse"
                :data-target="'#collapseMenu_'+ dep.id+ '_' + indexMenu"
                aria-expanded="false"
              >
                <i
                  v-if="menu.submenu.length > 0"
                  class="fa fa-arrow-down arrow-more"
                  aria-hidden="true"
                ></i>
                {{ menu.caption }}
              </button>
              <label class="btn-action get" :class="{'active': menu.active}" data-toggle="tooltip" data-placement="top" title="Ver registros">
                <input class="d-none" type="checkbox" :checked="menu.active" v-model="menu.active">  
                <i class="fa fa-uncheck" :class="{'fa-check': menu.active}"></i>                                         
              </label>
              <template v-if="menu.submenu.length == 0">                
                <label class="btn-action post" :class="{'active': menu.actions.post}" data-toggle="tooltip" data-placement="top" title="Agregar registros" :disabled="!menu.active">
                  <input class="d-none" type="checkbox" :checked="menu.actions.post" v-model="menu.actions.post">  
                  <i class="fa fa-plus"></i>                                         
                </label>
                <label class="btn-action put" :class="{'active': menu.actions.put}" data-toggle="tooltip" data-placement="top" title="Actualizar registros" :disabled="!menu.active">
                  <input class="d-none" type="checkbox" :checked="menu.actions.put" v-model="menu.actions.put">  
                  <i class="fa fa-edit"></i>                                         
                </label>
                <label class="btn-action delete" :class="{'active': menu.actions.delete}" data-toggle="tooltip" data-placement="top" title="Eliminar registros" :disabled="!menu.active">
                  <input class="d-none" type="checkbox" :checked="menu.actions.delete" v-model="menu.actions.delete">  
                  <i class="fa fa-times"></i>                                         
                </label>
                <div class="dropdown dropdown-special-actions" v-if="menu.specials.length > 0" title="Permisos especiales">
                  <button class="btn-action special-toggle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!menu.active">
                    <i class="fa fa-star" :class="{'text-warning': hasSpecial( menu.specials)}"></i>
                  </button>
                  <div class="dropdown-menu special" aria-labelledby="dropdownMenuButton" >
                    <span class="dropdown-item-text" v-for="specials in menu.specials" :key="specials.id" >
                        <label class="btn-action special" :class="{'active': specials.active}"  data-toggle="tooltip" data-placement="top" :title="specials.caption" >
                          <input class="d-none" type="checkbox" :checked="specials.active" v-model="specials.active">  
                          <i class="fa fa-check"></i> {{specials.caption}}
                        </label>
                    </span>
                  </div>
                </div>
              </template>
<!--               <label class="btn-action special" data-toggle="tooltip" data-placement="top" title="Acción Especial" >
                <input class="d-none" type="checkbox">  
                <i class="fa fa-star"></i> 
              </label> -->

            </div>
            <template v-if="menu.submenu.length > 0">
              <div class="mt-2 collapse" :id="'collapseMenu_'+ dep.id+ '_' + indexMenu">
                <div class="card card-body">
                  <!-- Submenu Iteration -->
                  <div v-for="(submenu, indexSub) in menu.submenu" :key="indexSub">
                    <div class="card-title">
                      <button class="btn btn-link btn-menu btn-submenu" type="button">{{ submenu.caption }}</button>
                      <label class="btn-action get" :class="{'active': submenu.active}" data-toggle="tooltip" data-placement="top" title="Ver registros" :disabled="!menu.active">
                        <input class="d-none" type="checkbox" :checked="submenu.active" v-model="submenu.active">  
                        <i class="fa fa-uncheck" :class="{'fa-check': submenu.active}"></i>                                                                         
                      </label>
                      <label class="btn-action post" :class="{'active': submenu.actions.post}" data-toggle="tooltip" data-placement="top" title="Agregar registros" :disabled="!submenu.active">
                        <input class="d-none" type="checkbox" :checked="submenu.actions.post" v-model="submenu.actions.post">  
                        <i class="fa fa-plus"></i>                                         
                      </label>
                      <label class="btn-action put" :class="{'active': submenu.actions.put}" data-toggle="tooltip" data-placement="top" title="Actualizar registros" :disabled="!submenu.active">
                        <input class="d-none" type="checkbox" :checked="submenu.actions.put" v-model="submenu.actions.put">  
                        <i class="fa fa-edit"></i>                                         
                      </label>
                      <label class="btn-action delete" :class="{'active': submenu.actions.delete}" data-toggle="tooltip" data-placement="top" title="Eliminar registros" :disabled="!submenu.active">
                        <input class="d-none" type="checkbox" :checked="submenu.actions.delete" v-model="submenu.actions.delete">  
                        <i class="fa fa-times"></i>                                         
                      </label>
                      <div class="dropdown dropdown-special-actions" v-if="submenu.specials.length > 0" title="Permisos especiales">
                        <button class="btn-action special-toggle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!submenu.active">
                          <i class="fa fa-star"></i>
                        </button>
                        <div class="dropdown-menu special" aria-labelledby="dropdownMenuButton" >
                          <span class="dropdown-item-text" v-for="specials in submenu.specials" :key="specials.id">
                              <label class="btn-action special" :class="{'active': specials.active}"  data-toggle="tooltip" data-placement="top" :title="specials.caption" >
                                <input class="d-none" type="checkbox" :checked="specials.active" v-model="specials.active">  
                                <i class="fa fa-check"></i> {{specials.caption}}
                              </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>


</template>

<script>
import _ from "underscore";

export default {
  props: ["userAcess","user"],
  methods: {
      hasSpecial(arr) {
        //comprueba si el usuario tiene permisos especiales *activados*.
        return arr.some(i => i.active);
      }
    }
  };
</script>

<style lang="scss" scoped>
.min-550{
  min-height: 550px;
}

.showAll {
  transition: all ease-in-out .2s;
}
</style>
